import {PropsWithChildren} from "react";
import classNames from "classnames";
import {AnimatePresence, motion} from "framer-motion";

import {CloseIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {ModalCore} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {HOMEMATCH_TINDER_DETAILS_CONTENT} from "../../constants/homematch_tinder_details_content";
import {homematchTinderSpringTransition} from "../../constants/homematch_tinder_motion";

import * as styles from "./HomematchTinderListingModal.module.css";

interface IProps extends PropsWithChildren {
    handleClose: () => void;
    onCloseButtonClick?: () => void;
    onCloseOutsideClick?: () => void;
    isLoading?: boolean;
    isOpen: boolean;
    offerCounterLabel?: string;
    overlayZIndex: number;
    className?: string;
}

const fadeMotionProps = {
    initial: {opacity: 0},
    animate: {opacity: 1},
    exit: {opacity: 0}
};

export const HomematchTinderListingModal = (props: IProps) => {
    const {children, className, handleClose, isLoading = false, isOpen, offerCounterLabel, overlayZIndex} = props;
    const {isMobile} = useUserDevice();

    return (
        <ModalCore
            className={classNames(styles.modalLayout, className)}
            contentClassName={classNames(styles.modalContent, isMobile && styles.modalContentMobileInset)}
            isOpen={isOpen}
            onModalClose={(event) => {
                if (event.type === "click") {
                    props.onCloseOutsideClick?.();
                } else if ("key" in event && event.key === "Escape") {
                    // No dedicated tracking value in the KB for Escape — treat it like the close button.
                    props.onCloseButtonClick?.();
                }

                handleClose();
            }}
            overlayStyle={{
                zIndex: overlayZIndex,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end"
            }}
            showCloseButton={false}
        >
            {isOpen && offerCounterLabel && (
                <Text className={styles.offerCounter} variant="body_copy_2">
                    {offerCounterLabel}
                </Text>
            )}

            <div className={styles.wrapper}>
                {isOpen && (
                    <button
                        aria-label={HOMEMATCH_TINDER_DETAILS_CONTENT.CLOSE_BUTTON}
                        className={styles.closeButton}
                        onClick={() => {
                            props.onCloseButtonClick?.();
                            handleClose();
                        }}
                        type="button"
                    >
                        <CloseIcon size={isMobile ? "1.6" : "2.4"} wrapperColor="var(--colors-white)" wrapperSize={isMobile ? "3.2" : "4.8"} />
                    </button>
                )}

                {isOpen && (
                    <>
                        <AnimatePresence>
                            {isLoading && (
                                <motion.div className={styles.shellLoaderPanel} {...fadeMotionProps}>
                                    <Loader size="lg" />
                                </motion.div>
                            )}
                        </AnimatePresence>

                        <AnimatePresence>
                            {!isLoading && (
                                <motion.div className={styles.content} {...fadeMotionProps} transition={homematchTinderSpringTransition}>
                                    {children}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </>
                )}
            </div>
        </ModalCore>
    );
};
import {PropsWithChildren} from "react";
import classNames from "classnames";
import {AnimatePresence, motion} from "framer-motion";

import {CloseIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {ModalCore} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {HOMEMATCH_TINDER_DETAILS_CONTENT} from "../../constants/homematch_tinder_details_content";
import {homematchTinderSpringTransition} from "../../constants/homematch_tinder_motion";

import * as styles from "./HomematchTinderListingModal.module.css";

interface IProps extends PropsWithChildren {
    handleClose: () => void;
    onCloseButtonClick?: () => void;
    onCloseOutsideClick?: () => void;
    isLoading?: boolean;
    isOpen: boolean;
    offerCounterLabel?: string;
    overlayZIndex: number;
    className?: string;
}

const fadeMotionProps = {
    initial: {opacity: 0},
    animate: {opacity: 1},
    exit: {opacity: 0}
};

export const HomematchTinderListingModal = (props: IProps) => {
    const {children, className, handleClose, isLoading = false, isOpen, offerCounterLabel, overlayZIndex} = props;
    const {isMobile} = useUserDevice();

    return (
        <ModalCore
            className={classNames(styles.modalLayout, className)}
            contentClassName={classNames(styles.modalContent, isMobile && styles.modalContentMobileInset)}
            isOpen={isOpen}
            onModalClose={(event) => {
                if (event.type === "click") {
                    props.onCloseOutsideClick?.();
                } else if ("key" in event && event.key === "Escape") {
                    // No dedicated tracking value in the KB for Escape — treat it like the close button.
                    props.onCloseButtonClick?.();
                }

                handleClose();
            }}
            overlayStyle={{
                zIndex: overlayZIndex,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end"
            }}
            showCloseButton={false}
        >
            {isOpen && offerCounterLabel && (
                <Text className={styles.offerCounter} variant="body_copy_2">
                    {offerCounterLabel}
                </Text>
            )}

            <div className={styles.wrapper}>
                {isOpen && (
                    <button
                        aria-label={HOMEMATCH_TINDER_DETAILS_CONTENT.CLOSE_BUTTON}
                        className={styles.closeButton}
                        onClick={() => {
                            props.onCloseButtonClick?.();
                            handleClose();
                        }}
                        type="button"
                    >
                        <CloseIcon size={isMobile ? "1.6" : "2.4"} wrapperColor="var(--colors-white)" wrapperSize={isMobile ? "3.2" : "4.8"} />
                    </button>
                )}

                {isOpen && (
                    <>
                        <AnimatePresence>
                            {isLoading && (
                                <motion.div className={styles.shellLoaderPanel} {...fadeMotionProps}>
                                    <Loader size="lg" />
                                </motion.div>
                            )}
                        </AnimatePresence>

                        <AnimatePresence>
                            {!isLoading && (
                                <motion.div className={styles.content} {...fadeMotionProps} transition={homematchTinderSpringTransition}>
                                    {children}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </>
                )}
            </div>
        </ModalCore>
    );
};
